import apiClient from "./apiClient";

const API_URL = `/kardex/medications`;

export const createMedications = async (medicationData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create-medications`, medicationData);
  return response.data;
};

export const createMedicationsWithoutInventoryDeduction = async (medicationData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create-medications-no-deduction`, medicationData);
  return response.data;
};

export const getMedicationsByPatientAndAdmission = async (patientId, admissionId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(
      `${API_URL}/by-patient-admission/${patientId}/${admissionId}`
    );
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      return [];
    }
    throw error;
  }
};

export default {
  createMedications,
  createMedicationsWithoutInventoryDeduction,
  getMedicationsByPatientAndAdmission,
}